import angular from 'angular';

import groupedGraphComponent from './grouped.component';

export default angular.module('dbm.dashboard.components.graph.grouped', [])
.component('dbmGroupedGraph', groupedGraphComponent)
.name;



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/graphs/grouped/index.js